import BaseRequest from './BaseRequest';

const schema = 'manager';
/**
 * key base on host:port
 */
export default class AdminRequest extends BaseRequest {
  /**
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  fetchAllAdmins() {
    const url = `${schema}/all-admins`;
    return this.get(url);
  }

  /**
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  fetchAdmins(params) {
    const url = `${schema}/admins`;
    return this.get(url, params);
  }

  /**
   * @param {Object} params
   * @param {string} params.display_name
   * @param {string} params.pubkey
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  createAdmin(params) {
    const url = `${schema}/create`;
    return this.post(url, params);
  }

  /**
   * @param {Object} params
   * @param {string} params.pos
   * @param {string} params.count
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  loginHistories(params) {
    const url = `${schema}/login-histories`;
    return this.get(url, params);
  }

  adminAuthInfo() {
    const url = `${schema}/author-info`;
    return this.get(url);
  }

  fetchAdminInfo(params) {
    const url = `${schema}/admin-info/${params}`;
    return this.get(url);
  }

  fetchAdminBalances() {
    const url = `${schema}/balances`;
    return this.get(url);
  }

  banAdmin(params) {
    const url = `${schema}/block/${params.pubkey}`;
    return this.put(url);
  }

  unBanAdmin(params) {
    const url = `${schema}/unlock/${params.pubkey}`;
    return this.put(url);
  }

  fetchOwnBalances() {
    const url = `${schema}/own-balances`;
    return this.get(url);
  }

  delAdmin(params) {
    const url = `${schema}/${params.id}`;
    return this.del(url, params);
  }
}
